import { Injectable } from '@angular/core';
import { moveItemInArray } from '@angular/cdk/drag-drop';

@Injectable({providedIn: 'root'})
export class HisReorderTableService {

    /**
     * Reorderable rows or columns by button click
     * direction = -1 = left, up; direction = 1 = right, down
     *
     */
    public moveRowOrColumn(elements: any[], element: any, direction: number): void {
        let indexOfCar: number = elements.findIndex( el => el === element );
        moveItemInArray( elements, indexOfCar, indexOfCar + direction );
    }
}
